// extracted by mini-css-extract-plugin
export default {"root":"sebsrXTcKbB2dEs_qko1","img":"GtODmOUZYEO5lhYXgDgz","text":"MS1E6pZz8jydU0w2b0oY","title":"Xt7VFn3ChDEV5CnuSYSA"};